import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailReferralComponent } from '../../components/email-referral/email-referral.component';
import {
  EmailReferralsLogoComponent,
  Language,
} from '../../components/email-referrals-logo/email-referrals-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  selector: 'email-referral-application-confirmation-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './referral-application-confirmation.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailReferralsLogoComponent,
    EmailMailgunIfDirective,
    EmailReferralComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class ReferralApplicationConfirmationTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<ReferralApplicationConfirmationTemplateData>;
}

export type ReferralApplicationConfirmationTemplateData = {
  title: string;
  p1_false: string;
  p1_true_html: string;
  job_button_text: string;
  job_button_link: string;
  status_button_text: string;
  referrals_button_link: string;
  candidate_name: string;
  offer_title: string;
  referral_status_visible: boolean;
  language: Language;
};

export const ReferralApplicationConfirmationTemplateMocks: ReferralApplicationConfirmationTemplateData[] =
  [
    {
      title: 'Your referral was successfully submitted!',
      p1_false:
        "Recruiters have been notified about your referral. To follow the referral's status, please contact the hiring team.",
      p1_true_html:
        'Recruiters have been notified about your referral. To follow the referral\'s status, visit the Referrals section or click "Check status" below.',
      job_button_text: 'Go to job',
      job_button_link: 'http://google.pl/',
      status_button_text: 'Check status',
      referrals_button_link: 'http://google.pl/',
      candidate_name: 'Jordan Ntolo',
      offer_title: 'Product Designer',
      referral_status_visible: true,
      language: {
        en: true,
        de: false,
        fr: false,
        nl: false,
      },
    },
  ];
